import { Typography, Chip } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import MissionLogStyles from "../../../styles/MissionLog.module.css";

export const OperationCardComponent = ({ operation, onClick, isSelected }) => {
  const hasNoAuthorizations = !operation.authorizations || operation.authorizations.length === 0;
  const isDeAuthorized = operation.authorizations.some(
    (auth) => auth.status === "de-authorized"
  );
  return (
    <div
      className={`${MissionLogStyles.missionmap_location_item} ${
        isSelected ? MissionLogStyles.active : ""
      } ${isDeAuthorized ? MissionLogStyles.de_authorized : ""}`}
      onClick={onClick}
    >
      <div>
        <div>
          <div>
            <Typography
              className={`${MissionLogStyles.location_item_title} ${
                isSelected ? MissionLogStyles.active : ""
              }`}
              textAlign="left"
            >
              FLZ{operation.operation_id}
              <span
                className={`${MissionLogStyles.card_content_span} ${
                  isDeAuthorized ? MissionLogStyles.de_authorized : ""
                }`}
              >
                {operation.date}
              </span>
            </Typography>
          </div>

          {hasNoAuthorizations && (
            <div className={MissionLogStyles.location_item_content}>
              <Typography variant="body2" textAlign="left" style={{ color: '#4caf50', fontStyle: 'italic', fontSize: '0.85rem' }}>
                No authorization required
              </Typography>
            </div>
          )}

          <div className={MissionLogStyles.location_item_content}>
            <Typography variant="body1" textAlign="left" sx={{ fontSize: { xs: '0.813rem', sm: '0.875rem', md: '1rem' } }}>
              Start Time:{" "}
            </Typography>
            <span
              className={` ${
                isDeAuthorized ? MissionLogStyles.de_authorized : ""
              }`}
              style={{ fontSize: window.innerWidth < 600 ? '0.813rem' : '0.875rem' }}
            >
              {operation.start_time} ({operation.timezone})
            </span>
          </div>
          <div className={MissionLogStyles.location_item_content}>
            <Typography variant="body1" textAlign="left" sx={{ fontSize: { xs: '0.813rem', sm: '0.875rem', md: '1rem' } }}>
              Operation Duration:{" "}
            </Typography>
            <span
              className={`${
                isDeAuthorized ? MissionLogStyles.de_authorized : ""
              }`}
              style={{ fontSize: window.innerWidth < 600 ? '0.813rem' : '0.875rem' }}
            >
              {operation.duration} minutes
            </span>
          </div>

          {operation.flightLogs?.length > 0 && (
            <div style={{ marginTop: 6 }}>
              <Chip
                icon={<CheckCircleIcon />}
                label={operation.flightLogs.length === 1 ? 'Flight Logged' : `${operation.flightLogs.length} Flights Logged`}
                size="small"
                color="success"
                variant="outlined"
                sx={{ fontSize: '0.72rem' }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
